import { PaginationDirection } from 'services/url';
import { Pagination } from 'services/search';

export const DOT_CHAR = '\u2022';

export const defaultPagination: Pagination = {
  pageNumber: 1,
  pageSize: 25,
  sort: {
    sortBy: 'CreatedOnUtc',
    direction: PaginationDirection.Descending,
  },
  totalPages: 25,
};

export const defaultMaximumPagination: Pagination = {
  ...defaultPagination,
  pageSize: 100,
};
